<template>
  <b-navbar toggleable="md" type="light" variant="light">
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

    <b-navbar-brand class="logo" href="https://developers.onelogin.com"></b-navbar-brand>

    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav>
        <b-nav-item to="/" :exact="true">OpenId Connect Inspector</b-nav-item>
        <b-nav-item to="/clients">Clients</b-nav-item>
        <b-nav-item to="/api">Resource Server Example</b-nav-item>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-nav-item href="https://developers.onelogin.com/openid-connect/api" right>API Documentation</b-nav-item>
        <b-nav-item @click="showHelp" right>Help</b-nav-item>
      </b-navbar-nav>
    </b-collapse>

    <help-modal :show="help" v-on:hide="hideHelp" />
  </b-navbar>
</template>

<script>
import HelpModal from './help.vue'

export default {
  data () {
    return {
      help: true
    }
  },

  components: {
    HelpModal
  },

  created () {
    this.help = (localStorage['help'] != 'hidden')
  },

  methods: {
    showHelp: function () {
      this.help = true
    },

    hideHelp: function () {
      localStorage['help'] = 'hidden'
      this.help = false
    }
  }
}
</script>
<style>
  .logo {
    width: 120px;
    height: 40px;
    background-repeat: no-repeat;
    background-image: url(https://developers.onelogin.com/assets/img/global/logo-sprite.svg);
    background-size: 250px;
    background-position: 0px 10px;
  }
</style>
